import { axiosInstance } from "../utils/axiosHelper"

export const getAllCollectionsService =async()=>{
   return await axiosInstance.get('user/cardCollectionTitles')
   .then((res)=>{
    return res.data
   })
   .catch((err)=>{
    return err.response.data
   })
}
export const getAllCollectionsPublicService =async()=>{
   return await axiosInstance.get('cardCollectionTitles')
   .then((res)=>{
    return res.data
   })
   .catch((err)=>{
    return err.response.data
   })
}
export const getAllCollectionsPublicServiceActive =async()=>{
   return await axiosInstance.get('/user/cardCollectionTitle/active')
   .then((res)=>{
    return res.data
   })
   .catch((err)=>{
    return err.response.data
   })
}
export const getCollabrate =async()=>{
   return await axiosInstance.get('/user/cardCollabrate')
   .then((res)=>{
    return res.data
   })
   .catch((err)=>{
    return err.response.data
   })
}
export const getLikes =async()=>{
   return await axiosInstance.get('/user/likes')
   .then((res)=>{
    return res.data
   })
   .catch((err)=>{
    return err.response.data
   })
}

export const PostLike = async (value,id) => {
   const formdata = new FormData();
 
   formdata.append("card_id", id);
   formdata.append("is_like", value);

   return await axiosInstance
     .post("user/likes", formdata)
     .then((res) => {
       return res.data;
     })
     .catch((err) => {
       return err.response.data;
     });
 };
export const PostComments = async (value,id) => {
   const formdata = new FormData();
 
   formdata.append("card_id", id);
   formdata.append("comment", value);

   return await axiosInstance
     .post("user/comments", formdata)
     .then((res) => {
       return res.data;
     })
     .catch((err) => {
       return err.response.data;
     });
 };
export const getAllSubCollectionsPublicService =async()=>{
   return await axiosInstance.get('user/cardCollectionSubTitles')
   .then((res)=>{
    return res.data
   })
   .catch((err)=>{
    return err.response.data
   })
}
export const getAllSubCollectionsActive =async()=>{
   return await axiosInstance.get('user/cardCollectionSubTitle/active')
   .then((res)=>{
    return res.data
   })
   .catch((err)=>{
    return err.response.data
   })
}
export const getAllChapter =async()=>{
   return await axiosInstance.get('user/chapters')
   .then((res)=>{
    return res.data
   })
   .catch((err)=>{
    return err.response.data
   })
}
export const getAllActiveChapter =async()=>{
   return await axiosInstance.get('user/chapter/active')
   .then((res)=>{
    return res.data
   })
   .catch((err)=>{
    return err.response.data
   })
}
